import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetBasesForApiKey(personalAccessToken?: string, enabled: boolean = false) {
  return useQuery({
    ...queryKeys.airtable.base(personalAccessToken)._ctx.list,
    enabled: enabled,
  });
}
